// frontend/src/services/lifecycleApi.js
import { http } from "./http";

function buildQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    q.set(k, String(v));
  });
  const qs = q.toString();
  return qs ? `?${qs}` : "";
}

/**
 * GET /api/admin/lifecycle/summary
 */
export function getLifecycleSummary(token) {
  return http(`/api/admin/lifecycle/summary`, { token });
}

/**
 * GET /api/admin/lifecycle/reminders/logs?limit=&offset=&q=&status=&bucket=&channel=
 * Returns: { rows, limit, offset, total }
 */
export function listLifecycleReminderLogs(token, params = {}) {
  return http(`/api/admin/lifecycle/reminders/logs${buildQuery(params)}`, { token });
}

/**
 * POST /api/admin/lifecycle/reminders/run?dryRun=1
 * Body optional: { buckets?: string[] }
 */
export function runLifecycleRemindersOnce(token, { dryRun = true, buckets } = {}) {
  return http(`/api/admin/lifecycle/reminders/run${buildQuery({ dryRun: dryRun ? 1 : 0 })}`, {
    token,
    method: "POST",
    body: { buckets },
  });
}
